<template>
  <div>
    <div class="product_box">
      <div v-if="dataList.length > 0">
        <div
          class="product_item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="dataClick(item)"
        >
          <div class="img_box">
            <img :src="item.url || wqUrl + 'wq_service.png'" mode="" />
          </div>
          <div class="product_info">
            <div class="title_box">
              <div class="title">{{ item.title || item.name }}</div>
            </div>
            <div class="writer_box">
              <div class="label">
                {{
                  userData.remark
                    ? userData.name + userData.remark
                    : userData.name
                }}
              </div>
              <div class="label" @click.stop="show_pop = true">
                小语AI实验室
              </div>
            </div>
            <div class="bottom">
              <div class="price_box">
                <span class="now_price"
                  ><span style="font-size: 14px">￥</span
                  >{{ item.selectPrice }}</span
                >
              </div>
              <div class="score_box">
                <div
                  style="margin-left: 0"
                  class=""
                  @click.stop="goUserRate(item.id)"
                >
                  <img
                    style="width: 14px; height: 14px"
                    :src="wqUrl + 'aiExistingWritings_score.png'"
                    mode=""
                  />
                  <span>{{ item.star }}</span>
                </div>
                <div class="" @click.stop="commentClick(item)">
                  <img
                    :src="wqUrl + 'aiExistingWritings_comment.png'"
                    mode=""
                  />
                  <span>{{ item.contents || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-else style="margin-top: 100px">
        <u-empty
          mode="data"
          width="95px"
          height="95px"
          text="暂无内容"
          icon="https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/all_page_nullTowImg.png"
        >
        </u-empty>
      </div>
    </div>
    <el-dialog
      :visible.sync="show_pop"
      mode="center"
      :round="10"
      :safeAreaInsetBottom="false"
      width="30%"
      :before-close="closePop"
    >
      <div class="xiaoyu_box">
        <img :src="wqUrl + 'aiExistingWritings_xiaoyu.png'" mode="" />
        <div class="title">
          <img :src="wqUrl + 'editedBooks_dialogTip.png'" mode="" />
          小语AI实验室简介
        </div>
        <div class="content">
          小语AI实验室成立于2020年8月，是深圳写手智能科技公司的重要AI研发机构，主要从事垂直细分领域AI语言模型构建与训练、大型语料库建设、多模态AIGC应用等领域研究，致力于为AIGC服务提供核心技术支持。
        </div>
        <div class="btn" @click="closePop">已了解</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { showProfessionalServicesList } from 'api/professionServer'
export default {
  props: ['userData'],
  data() {
    return {
      wqUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/', // 图片url
      show_pop: false,
      dataList: [],
    }
  },
  created() {
    this.showProfessionalServicesList()
  },
  watch: {
    userData(v) {
      this.showProfessionalServicesList()
    },
  },
  methods: {
    // 去用户评级
    goUserRate(id) {},
    commentClick(v) {},
    // 关闭小语介绍弹窗
    closePop() {
      this.show_pop = false
    },
    // 去详情
    dataClick(v) {
      this.$bus.$emit('dataClick', v)
      console.log(v)
    },

    async showProfessionalServicesList() {
      let res = await showProfessionalServicesList({
        // architectId: 4739
        architectId: this.userData.userId,
      })
      if (res.code !== 200) return
      this.dataList = res.data.data
    },
  },
}
</script>

<style lang="scss" scoped>
.product_box {
  padding: 0 15px;
  box-sizing: border-box;

  .product_item {
    display: flex;
    padding: 12px 0;

    .img_box {
      width: 100px;
      height: 100px;
      background: #ccc;
      border-radius: 10px;
      margin-right: 15px;
      overflow: hidden;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    .product_info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title_box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          cursor: pointer;
          max-width: 175px;
          font-size: 17px;
          color: #333;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .collect_box {
          > img {
            width: 15px;
            height: 15px;
            vertical-align: middle;
          }
        }
      }

      .writer_box {
        display: flex;
        margin-top: 10px;

        .label {
          cursor: pointer;
          height: 19px;
          line-height: 19px;
          padding: 0 6px;
          background: #f7f7f7;
          border-radius: 3px;
          font-size: 11px;
          color: #999;
          margin-right: 10px;
        }
      }

      .bottom {
        display: flex;
        // align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .price_box {
          .now_price {
            color: #f52c26;
            font-size: 20px;
            margin-right: 9px;
          }
        }

        .score_box {
          display: flex;
          align-items: center;

          > div {
            margin-left: 15px;
            min-width: 40px;

            > img {
              width: 12px;
              height: 12px;
              vertical-align: middle;
              margin-top: -2px;
              margin-right: 5px;
            }

            > span {
              font-size: 13px;
              color: #999;
            }
          }
        }
      }
    }
  }
}

.xiaoyu_box {
  position: relative;
  width: 100%;

  > img {
    width: 114px;
    height: 103px;
    position: absolute;
    top: 25px;
    right: 10px;
  }

  .title {
    cursor: pointer;
    padding: 28px 0 0 28px;
    box-sizing: border-box;
    font-size: 17px;
    color: #333;
    font-weight: bold;

    > img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 10px;
    }
  }

  .content {
    margin-top: 40px;
    padding: 0 45px;
    font-size: 14px;
    color: #333;
    line-height: 28px;
  }

  .btn {
    cursor: pointer;
    margin-top: 30px;
    margin-bottom: 25px;
    text-align: center;
    font-size: 16px;
    color: #326afb;
  }
}
</style>
